import * as lottie from "lottie-web";
import {WPApi} from "../common/wp-api";
import pageGlobals from "../common/globals";

const wp = new WPApi();

jQuery(document).ready(($) => {
    $('.reactions .reaction').each(function () {


        let $this = $(this);
        let animationElement = $('.reaction-animation', this).get(0);
        let animationId = $(animationElement).attr('id');
        const animationData = require(`../../animations/${animationId}.json`);

        let anim = lottie.default.loadAnimation({
            container: animationElement, // Required
            animationData, // Required
            renderer: 'svg', // Required
            loop: false, // Optional
            autoplay: false, // Optional
            name: animationId,
        });

        $this.data('anim', anim);

        $this.mouseenter(function () {
            let animationElement = $('.reaction-animation', this).get(0);
            // noinspection JSPotentiallyInvalidUsageOfThis
            lottie.default.play($(animationElement).attr('id'));
        });

        $this.mouseleave(function () {
            let animationElement = $('.reaction-animation', this).get(0);
            let anim = $(this).data('anim');
            anim.addEventListener("complete", () => {
                // noinspection JSPotentiallyInvalidUsageOfThis
                lottie.default.stop($(animationElement).attr('id'));
            });
        });

        $this.click(reactToPost)

    });


    async function reactToPost() {
        let $reaction = $(this);
        $('.reaction').unbind('click');

        let label = $('.reaction-label',$reaction).text();
        sport1Analytics.sendEvent('article-page', 'emoji-click', label.trim());

        const reactionId = $reaction.data('reaction-id');

        try {
            const data = await wp.post('sport1/v1/reactions', {post_id: pageGlobals.post.id, value: reactionId});
            setSelectedReactionWithPercentages($reaction, data)
        } catch (e) {
            console.error(e);
        }
    }

    /**
     *
     * */
    function setSelectedReactionWithPercentages($selectedReaction, reactionsData) {
        $selectedReaction.addClass('selected');
        for (let reactionName in reactionsData) {
            if (reactionsData.hasOwnProperty(reactionName)) {
                let $reactionBlock = $(`.reaction[data-reaction-name=${reactionName}]`);
                let reactionText = $('.reaction-label', $reactionBlock).text();
                let percentageText = `${reactionsData[reactionName]}%`;
                let percentageHtml = `<span class="reaction-percentage-label">${reactionText}</span> <span class="reaction-percentage-value">${percentageText}</span>`;
                $('.percentage', $reactionBlock).html(percentageHtml);
                $reactionBlock.addClass('with-results');
            }
        }
    }
});

